// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-bundles-help-index-js": () => import("./../../../src/bundles/help/index.js" /* webpackChunkName: "component---src-bundles-help-index-js" */),
  "component---src-bundles-help-search-index-js": () => import("./../../../src/bundles/help/search/index.js" /* webpackChunkName: "component---src-bundles-help-search-index-js" */),
  "component---src-templates-category-index-js": () => import("./../../../src/templates/category/index.js" /* webpackChunkName: "component---src-templates-category-index-js" */)
}

